module.exports = __webpack_public_path__ + "img/logo1.89228125.png";